import React from 'react';
import {AiMentionsChatDemoContent, AiMentionsHeroContent} from "../../models/AiMentionsContent";
import ChatDemo from "./ChatDemo";

// Every line after the first carries the accent color, per the design - the same
// \n convention the homepage hero uses.
const renderTitle = (title: string) => title.split('\n').map((line, index) => (
    <React.Fragment key={`${index}-${line}`}>
        {index > 0 && <br/>}
        {index === 0 ? line : <span className="lnk-aim__hero-title-accent">{line}</span>}
    </React.Fragment>
));

interface AiMentionsHeroProps {
    hero: AiMentionsHeroContent;
    chatDemo: AiMentionsChatDemoContent;
    onPrimaryCta: () => void;
    onSecondaryCta: () => void;
}

const AiMentionsHero: React.FC<AiMentionsHeroProps> = ({hero, chatDemo, onPrimaryCta, onSecondaryCta}) => (
    <section className="lnk-aim__hero">
        <h1 className="lnk-aim__hero-title">{renderTitle(hero.title)}</h1>

        <p className="lnk-aim__hero-subtitle">{hero.subtitle}</p>

        <div className="lnk-aim__ctas">
            <button type="button" className="lnk-aim__cta lnk-aim__cta--primary" onClick={onPrimaryCta}>
                {hero.ctaPrimaryLabel}
            </button>
            <button type="button" className="lnk-aim__cta lnk-aim__cta--secondary" onClick={onSecondaryCta}>
                {hero.ctaSecondaryLabel}
            </button>
        </div>

        <ChatDemo content={chatDemo}/>
    </section>
);

export default AiMentionsHero;
